import { formatMoney } from '@experience/money-utils';
import { computed } from 'vue';
import ru from '../i18n/ru.json';
import { tripsterStandard } from '@experience/money-utils/dist/numbers/tripsterStandard';
import { type CurrencyCode, getCurrencySymbol } from '@/shared/lib/currency';
import { useI18n } from '@experience/i18n';
import { useCategoryStore } from '@/shared/store';
import { EExperienceFilterType } from '@/widgets/filtersBlock/model/interface';

export function useFilterPriceTitle() {
  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const categoryStore = useCategoryStore();

  const DEFAULT_TITLE = t('price.defaultTitle');

  const headerTitle = computed(() => t('price.headerPersonTitle', { currentSign: currentSign.value }));

  const currentSign = computed(() => getCurrencySymbol(categoryStore.currencyCode));

  const title = computed(() => {
    const price = categoryStore.filters[EExperienceFilterType.PRICE].price;

    const [firstPrice, secondPrice] = price;

    if (firstPrice === null && secondPrice === null) {
      return DEFAULT_TITLE;
    }

    if (firstPrice && secondPrice === null) {
      return t('price.fromPriceTitle', {
        price: formatMoney(firstPrice, categoryStore.currencyCode as CurrencyCode),
      });
    }

    if (secondPrice && firstPrice === null) {
      return t('price.toPriceTitle', {
        price: formatMoney(secondPrice, categoryStore.currencyCode as CurrencyCode),
      });
    }

    if (firstPrice && secondPrice) {
      return firstPrice === secondPrice
        ? formatMoney(secondPrice, categoryStore.currencyCode as CurrencyCode)
        : formatMoney(
            `${tripsterStandard(firstPrice)}–${tripsterStandard(secondPrice)}`,
            categoryStore.currencyCode as CurrencyCode,
          );
    }

    return DEFAULT_TITLE;
  });

  const isActive = computed(() => title.value !== DEFAULT_TITLE);

  return {
    title,
    headerTitle,
    isActive,
  };
}
